<template>
   <a-config-provider :locale="locale">
    <div id="app">
    <router-view />
  </div>
 </a-config-provider>

</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
export default {
   data () {
    return {
      moment,
      locale: zhCN,
    }
  },
  
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
